import React from 'react';
import { FormikInput } from 'components/UiKit/FormikFields';
import FormField from 'screens/Companies/components/FormField';

const AddressLineOneField = () => {
  return (
    <FormField label="Address Line 1" htmlFor="line1">
      <FormikInput id="line1" name="address.line1" />
    </FormField>
  );
};

export default AddressLineOneField;
